import { Pagination, Fx } from 'Components';
import { PaginationProps } from 'antd/es/pagination';
import "./pagination.scss";

const PaginationElement = (props: PaginationProps) => {
    return <Fx shrink={0} fullWidth justify="center">
        <Pagination {...props} showSizeChanger={false} hideOnSinglePage={true} responsive={true} />
    </Fx>
}

export default PaginationElement;